import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { getBrand, getBrandConfig } from './app/shared/services/branding';

// Apply host-based branding before bootstrap to avoid a flash of the wrong theme.
const brandConfig = getBrandConfig();
document.documentElement.setAttribute('data-brand', getBrand());
document.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute('href', brandConfig.favicon);
document.title = `Add Card - ${brandConfig.displayName}`;

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
